import { render, staticRenderFns } from "./TabelaDeferidas.vue?vue&type=template&id=306219ed&scoped=true"
import script from "./TabelaDeferidas.vue?vue&type=script&lang=js"
export * from "./TabelaDeferidas.vue?vue&type=script&lang=js"
import style0 from "./TabelaDeferidas.vue?vue&type=style&index=0&id=306219ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306219ed",
  null
  
)

export default component.exports